<template>
  <div>
    <error :error="error"/>
    <overwatchLoader/>
  </div>
</template>

<script>
import OverwatchLoader from '../loader/overwatch'
import Error from '../error/error'

export default {
  name: 'app',
  data () {
    return {
      errorMsg: '',
      error: null
    }
  },
  components: {
    OverwatchLoader,
    Error
  },
  computed: {
    id () {
      return this.$route.query.deviceId
    },
    query () {
      let query = {}
      query.deviceId = this.id
      if (this.$route.query.user) {
        query.user = this.$route.query.user
      }
      if (this.$route.query.pass) {
        query.pass = this.$route.query.pass
      }
      return query
    }
  },
  methods: {
    redirect (device) {
      if (device) {
        let site = device.get('site')
        let template = device.get('template')
        let route = `/${template.get('data').brand}/${template.get('data').screenType}/${template.get('data').name}/${site.get('data').code}`
        this.$router.push({ path: route, query: this.query })
      } else {
        this.error = {title: 'Error', message: 'Device not found.'}
      }
    }
  },
  mounted: function () {
    this.$vueParse.Parse.Cloud.run('deviceExists', { id: this.id })
    .then(exists => {
      if (exists) { // device exists
        this.$authManager.auth(exists) // authentication required to be able to access device data
        .then(user => {
          this.$dm.setDevice(this.$route)
          .then(device => {
            this.redirect(device)
          })
        }).catch(error => {
          this.error = {title: 'Access rights error', message: 'Check your authentication and access rights'}
          console.log(error)
        })
      } else {
        this.$router.push({name: 'Params', query: this.query})
      }
    }).catch(error => { // Network error : try with data in store
      let device = this.$store.getters.device
      console.log('Read device from store', error, device)
      this.redirect(device)
    })
  }
}
</script>

<style lang='scss'>
@import '../../../scss/global.scss';

#app {
  @extend .gradientBackground;

  #error {
    position: absolute;
    top: 47vh;
    left: 30vw;
    width: 40vw;
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    text-transform: uppercase;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/routing/Redirect.vue